import React from "react";
import "./AppDev.css";

export const AppDev = () => {
  return (
    <main className="bodyContent appDevPage">
      <section className="appDevContent">
        <h1>Mobile App Design &amp; Development</h1>

        <p>
          We don&apos;t just build apps — we build products people actually use.
        </p>

        <p>
          From idea to launch, we turn concepts into powerful mobile experiences
          that users love. Fast, scalable, and built for real-world usage — not
          just demo screens.
        </p>

        <h2>What makes us different</h2>

        <ul>
          <li>Built for real users, not just presentations</li>
          <li>Optimized for performance &amp; retention</li>
          <li>Designed with growth in mind</li>
          <li>Ready for future scaling (AI, backend, integrations)</li>
        </ul>
      </section>
    </main>
  );
};
